module.exports = __webpack_public_path__ + "files/10ae960040dc8f73f6c28c4a165febcf.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/sourcesanspro-italic-webfont.woff
 ** module id = 1022
 ** module chunks = 0
 **/